import { cn } from "@/lib/utils";
import { NavLink } from "react-router-dom";

export const NavLinkTouchDevice = ({
  children,
  to,
  currentRoute,
  isInDrawer = false,
  externalLink = false,
  onClick,
}: {
  children: React.ReactNode;
  to: string;
  currentRoute: string;
  isInDrawer?: boolean;
  externalLink?: boolean;
  onClick?: () => void;
}) => {
  const isActive = currentRoute === to;
  const className = cn(
    "flex items-center w-full touch-action-manipulation",
    isInDrawer ? "h-12 px-6" : "h-12.5 justify-center",
    isActive ? "text-white" : "text-new-gray-450",
  );
  if (externalLink) {
    return (
      <a
        href={to}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <>
      <NavLink
        to={to}
        className={className}
        onClick={(e) => {
          window.scrollTo(0, 0);
          onClick?.();
        }}
      >
        {children}
      </NavLink>
    </>
  );
};
